/* eslint-disable react/no-unknown-property */
import Image from 'next/image'

export default function Sec4() {
  return (
    <div>
      <section>
        <div className="grid md:col-span-12 relative">
          <div className="">
            <div className="pb-6 mb-20 md:mb-4 lg:max-w-[650px] tracking-[-1.21px]">
              <h2 className="sectionTitle !text-left">
                Gain valuable insights instantly
              </h2>
            </div>

            <Image
              alt="Image"
              src="/ai/illustration-two-girls-looking-down-surprised"
              width={221}
              height={150}
              className="z-1000000 absolute right-[3%] md:bottom-1 -bottom-24"
            />
          </div>
        </div>

        <div className="border bg-gray-100 rounded-md md:mt-[-12px] mt-20 lg:width-full">
          <div className="flex flex-col top-[24px] lg:px-8 lg:py-6 px-6 py-2">
            <div className="border-transparent">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 64 64"
                width="1em"
                className="w-[21px] h-[26px]"
                style={{
                  fill: '#9d34da',
                  color: '#9d34da'
                }}
              >
                <defs fill="currentColor"></defs>
                <path
                  d="m17,51.5c0,2.49-2.01,4.5-4.5,4.5s-4.5-2.01-4.5-4.5,2.01-4.5,4.5-4.5,4.5,2.01,4.5,4.5Zm41-15.5c0,7.73-6.27,14-14,14-1,0-1.97-.11-2.91-.31-2.55,2.65-6.12,4.31-10.09,4.31-6.35,0-11.7-4.23-13.42-10.02-6.43-.22-11.58-5.49-11.58-11.98,0-4.86,2.89-9.03,7.05-10.92.48-8.41,7.43-15.08,15.95-15.08,4.43,0,8.43,1.8,11.33,4.7,1.14-.45,2.37-.7,3.67-.7,5.52,0,10,4.48,10,10,0,1.83-.5,3.53-1.35,5,3.25,2.56,5.35,6.53,5.35,11Zm-34-6c0-2.21-1.79-4-4-4s-4,1.79-4,4,1.79,4,4,4,4-1.79,4-4Zm12,0c0-2.21-1.79-4-4-4s-4,1.79-4,4,1.79,4,4,4,4-1.79,4-4Zm12,0c0-2.21-1.79-4-4-4s-4,1.79-4,4,1.79,4,4,4,4-1.79,4-4Z"
                  fill="currentColor"
                ></path>
              </svg>
            </div>
            <p className="postTitle">
              Data-driven decision-making <br />
              Powered by AI
            </p>
            <span className="text-slate-700 text-lg lg:max-w-[463px]">
              Discover patterns and trends in user responses with AI-generated
              analytics that empower you to make smarter decisions.
            </span>
          </div>
          {/* video */}
          <div className="px-8 pt-4">
            <video
              src="/ai/Task.mp4"
              autoPlay
              loop
              muted
              className="border rounded-xl w-full h-full "
            ></video>
          </div>
        </div>
        <div className="grid lg:grid-cols-3 md:grid-cols-2 grid-cols-1 gap-9 my-8">
          <div className="border-gray-100 bg-gray-100 rounded-lg">
            <div className="px-8 pt-8">
              <Image
                width={26}
                height={26}
                alt=""
                src="/ai/Action.svg"
                className="text-[#9d34da]"
              />
              <h2 className="font-bold py-2 text-[18px]">Action items</h2>
              <p className="text-[16px]">
                Analyze meeting notes to generate next steps, instantly.
              </p>
              <Image
                width={245}
                height={159}
                alt=""
                className="ml-[33px] mb-1 mt-7"
                src="/ai/Action.webp"
              />
            </div>
          </div>
          <div className="border-gray-100 bg-gray-100 rounded-lg">
            <div className="px-8 pt-8">
              <Image width={26} height={26} alt="" src="/ai/summaries.png" />
              <h2 className="font-bold py-2 text-[18px]">Summaries</h2>
              <p className="text-[16px]">
                Generate a TL;DR across hundreds of items, all at once.
              </p>
              <Image
                width={245}
                height={159}
                alt=""
                className="ml-[33px] mb-1 mt-7"
                src="/ai/Summary.png"
              />
            </div>
          </div>
          <div className="border-gray-100 bg-gray-100 rounded-lg">
            <div className="px-8 pt-8">
              <Image width={26} height={26} alt="" src="/ai/Insight.svg" />
              <h2 className="font-bold py-2 text-[18px]">Insights</h2>
              <p className="text-[16px]">
                See the takeaways from sales calls, research sessions & more.
              </p>
              <Image
                width={245}
                height={159}
                alt=""
                className="ml-[33px] mb-1 mt-7"
                src="/ai/Insight.webp"
              />
            </div>
          </div>
        </div>
      </section>
    </div>
  )
}
